import { makeAutoObservable, runInAction } from 'mobx';
import { cacheService } from './services/cacheService';
import { apiServiceColyseusApp, apiServiceV2 } from './services/apiService';
import { authorizationStore } from './modules/authorization/authorization.store';
import { NotificationsContent } from './helpers/notifications_content';
import { NotificatonProps } from './components/modalcontainer/modalcontainer.type';
import { logoutPopupStore } from './components/logoutPopup/logoutPopup.store';
import { unityheaderStore } from './components/unityheader/unityheader.store';
import { sendMessageStore } from './modules/unityLayout/sendMessage.store';
import { uploadModelStore } from './components/Map3d/upload.store';
import { dashboardStore } from './layout/dashboard/dashboard.store';
import { socketStore } from './socket.store';
import { isMobile, osName } from 'react-device-detect';

class GlobalStore {
  isLogin = false;

  toastStatus = false;

  toastType: string | null = null;

  otherContentModal = false;

  otherContentType = '';

  otherContentData: any;

  logoutLoading = false;

  guestPopupState = false;

  notification = false;

  refreshPage: boolean = false;

  notificationContent: NotificatonProps;

  navigation: Function;

  smartBannerData: any = {};

  userData:
    | {
        id: number;
        username: string;
        email: string;
        hoory_website_token: string;
        avatar_url: string;
        avatar_image_url: string;
        is_superuser: boolean;
        has_winnings: boolean;
        apple_verified: boolean;
        login: string;
        auth_provider: string;
        balance: number;
        vigogo_countdown: number;
        gender: number;
        birthday: string;
        platforms: {};
        isGuest: boolean;
      }
    | any = {};

  constructor() {
    makeAutoObservable(this);
  }

  setIsLogin = (status: boolean) => {
    this.isLogin = status;
  };

  setGuestPopupState = (
    status: boolean,
    redirectUrl: string = '',
    refreshPage: boolean | undefined = undefined,
  ) => {
    if (status) {
      authorizationStore.setRedirectUrl(redirectUrl);
    }
    this.guestPopupState = status;
    if (typeof refreshPage === 'boolean') this.setRefreshPage(refreshPage);
  };

  setRefreshPage = (bool: boolean) => {
    this.refreshPage = bool;
  };

  setToasts = (status: boolean, type: string | null) => {
    this.toastType = type;
    this.toastStatus = status;
    setTimeout(() => (this.toastStatus = false), 5000);
  };

  setOtherContentModal = (status: boolean) => {
    this.otherContentModal = status;
  };

  openOtherContentModal = (type: string, data: any) => {
    this.otherContentData = data;
    this.otherContentType = type;
    this.setOtherContentModal(true);
  };

  setNavigation = (func: Function) => {
    this.navigation = func;
  };

  setNotifications = (
    status: boolean,
    type?: string,
    message?: string,
    time?: any,
  ) => {
    this.notification = status;
    if (status && type) {
      this.notificationContent = NotificationsContent[type];
      this.notificationContent.action = this[
        NotificationsContent[type].action as keyof GlobalStore
      ] as Function;
      if (message) this.notificationContent.headerText!.subTitle = message;
      if (time) this.notificationContent!.time = time;
    }
  };

  closePopup = () => {
    this.setNotifications(false);
  };

  navigateToMain = () => {
    this.setNotifications(false);
    this?.navigation('/');
  };

  goBack = () => {
    this.setNotifications(false);
    this.navigation(-1);
  };

  getUserData = async () => {
    try {
      const response = await apiServiceV2.getCurrentUser();
      if (response.error) return response;
      this.setIsLogin(response.data?.userAccessType === 1);
      authorizationStore.setClearSearchParams(
        response.data?.userAccessType === 1,
      );

      const isSuperUser =
        response.data.email === 'georgi.mkhitaryan@softconstruct.com';
      cacheService.set('Id', response.data.id);
      uploadModelStore.setIsSuperUser(isSuperUser);
      response.data?.userAccessType === 1 &&
        dashboardStore.setAuthPopupActive(false);
      this.setUserData({
        ...response.data,
        token: cacheService.get('auth_token'),
      });
      return response;
    } catch (error) {
      this.setIsLogin(false);
      window.location.pathname.startsWith('/myspaces') && this.navigation('/');
      console.log(error);
      return false;
    }
  };

  createGuestUser = async (success: Function) => {
    try {
      const res = await apiServiceV2.getGuestUser({
        sessionToken: `${Date.now()}`,
      });
      cacheService.set('auth_token', res.data.accessToken.token);
      await this.getUserData();
      success();
    } catch (error) {
      console.log(error);
    }
  };

  hasAvailableRoom = async () => {};

  saveUserData = async (data: {
    username: string;
    hooryToken: string;
    gender: number;
    birthday: string;
  }) => {
    const response = await apiServiceV2.editUserData(data);
    if (!response.error) {
      runInAction(() => {
        this.setUserData({
          ...this.userData,
          ...response.data,
          hooryWebsiteToken: response?.data.hooryToken,
        });
      });
      globalStore.setToasts(true, 'its_success');
    } else {
      globalStore.setToasts(true, 'username_exist');
      console.warn('ERROR');
    }
  };

  projectConfiguration = async () => {
    if (cacheService.get('auth_token')) await this.getUserData();
    if (isMobile) await this.fetchAppData();
    // if(reloadPage) window.location.assign(window.location.pathname);
  };

  clearData = () => {
    this.setUserData({});
    authorizationStore.userData = {};
  };

  logout = async () => {
    this.logoutLoading = true;
    try {
      await apiServiceV2.logOut();
      socketStore.logOut();
      cacheService.clear();
      logoutPopupStore.setShowLogoutPopup(false);
      this.setUserData({});
      this.isLogin = false;
      if (window.location.pathname === '/myspaces') this.navigation('/');
    } catch (error) {
      console.log(error);
    }
    this.logoutLoading = false;
  };

  dubleLoginLogut = async () => {
    await this.logout();
    sendMessageStore.sendMessage &&
      sendMessageStore.sendMessage(
        'ReactManager',
        'UnloadSpace',
        `${cacheService.getRoomId}`,
      );
    unityheaderStore.onLeaveRoom();
    cacheService.clear();
    this?.navigation('/');
    this.logoutLoading = false;
    this.isLogin = false;
    logoutPopupStore.setShowLogoutPopup(false);
  };

  userIsGuest = () => this.userData?.userAccessType !== 1;

  setUserData = (data: any) => {
    this.userData = data;
  };

  setSmartBannerData = (data: any) => {
    this.smartBannerData = data;
  };

  fetchAppData = async () => {
    try {
      const response = await apiServiceColyseusApp.getSmartBanner();
      const appVersion = Number.parseFloat(
        localStorage.getItem('appVersion') || '0',
      );
      const appVersionServer = Number.parseFloat(
        response[osName.toLowerCase()].version,
      );
      const hideSmartBannerState = /true/.test(
        localStorage.getItem('hideSmartBanner') || 'false',
      );
      if (
        !hideSmartBannerState ||
        (hideSmartBannerState && appVersionServer > appVersion)
      ) {
        localStorage.setItem('hideSmartBanner', 'false');
        localStorage.setItem(
          'appVersion',
          response[osName.toLowerCase()].version,
        );
        this.setSmartBannerData(response);
      }
    } catch (error) {
      console.error('Failed to fetch app data:', error);
    }
  };
}

export const globalStore: GlobalStore = new GlobalStore();
